import {SimpleListActions} from 'mc/lib/list';
import {Api} from '../api';

const AREA = 'zadostList';

export function fetchIfNeeded() {
    return SimpleListActions.fetchIfNeeded(AREA, true, Api.getZadostList);
}

export function invalidate() {
    return SimpleListActions.invalidate(AREA);
}
